module.exports = __webpack_public_path__ + "img/T6-A-rc_3.e3c6833a.png";